/* eslint-disable prettier/prettier */

import {
  getUsuarios,
  insertUsuario,
  updateStatusUsuario,
  ObtenerUsuarioPorId,
  updateContrasena,
  ResetearPasswordUsuario,
} from "../apis";
import axios from "axios";
import toast from "react-hot-toast";
import { store } from "../store";

import {
  getusers,
  setUserAdd,
  isLoadingUsers,
  updateUser,
  updateStatusSuccess,
} from "./usuariosSlice";

export function InformacionInicialUsuarios(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoadingUsers(true));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(getUsuarios(), header)
    .then((response) => {
      dispatch(getusers(response.data.data));
      dispatch(isLoadingUsers(false));
    })
    .catch((error) => {
      dispatch(isLoadingUsers(false));
    });
}

export const InsertarUsuarios = (data) => async (dispatch) => {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");

  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(insertUsuario(), data, header);
    toast.remove(id);
    if (response.data.code === "Error") {
      if (response.data.mensaje == "Ya existe un usuario con ese nombre o nombre completo.") {
        toast.error(response.data.mensaje);
      } else {
        toast.error("Error al insertar el usuario");
      }
      return false;
    }
    if (response.data.code === "Ok") {
      dispatch(setUserAdd(response.data.data));
      toast.success("Éxito al insertar el usuario");
      return true;
    }
  } catch (error) {
    toast.error("Error al insertar el usuario.\nContace a soporte");
    return false;
  }
};

export function ActualizarUsuario(dispatch, data) {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(insertUsuario(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al modificar el usuario");
      }
      if (response.data.code === "Ok") {
        dispatch(updateUser(response.data.data));
        toast.success("éxito al modifical el usuario");
      }
    })
    .catch((error) => {
      toast.error("Error al modificar el usuario");
    });
}

export function UpdateStatusUsuario(dispatch, data, activo) {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando, por favor espere...");
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(
      `${updateStatusUsuario()}?idUsuarioModificar=${data.idUsuario}&activo=${activo}&userid=${
        usuario.idUsuario
      }`,
      data,
      header
    )
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al modificar el estatus del usuario");
      }
      if (response.data.code === "Ok") {
        data.activo = activo;
        dispatch(updateStatusSuccess({ ...data }));
        toast.success("Éxito al modificar el estatus del usuario");
      }
    })
    .catch((error) => {});
}

export const getPermisosUsurios = (idRol) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Cargando datos de usuario, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      ObtenerUsuarioPorId().concat("?idUsuario=").concat(idRol),
      header
    );
    toast.remove(id);
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};

export const CambiarContrasena = (data) => async (dispatch) => {
  const token = store.getState().login.token;

  let id = toast.loading("Procesando, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(updateContrasena(), data, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("Contraseña cambiada con éxito");
      return true;
    } else {
      toast.error(response.data.mensaje);
      return false;
    }
  } catch (error) {
    toast.error("Error al cambiar la contraseña");
    toast.remove(id);
    return false;
  }
};

export const ResetearContrasena = (idUsuario) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    var data = {
      idUsuarioModificar: idUsuario,
      idUsuarioModifica: usuario?.idUsuario,
    };
    const response = await axios.put(ResetearPasswordUsuario(), data, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("La contraseña se restableció correctamente");
      return true;
    } else {
      toast.error(response.data.mensaje);
      return false;
    }
  } catch (error) {
    toast.error("Ocurrio un error");
    toast.remove(id);
    return false;
  }
};
